import {Base} from "@/api/Base"

export class LeaveList extends Base {
    path = "leave/list"
}